/* Guía de Talles Deliver — piloto v1.1 (29-jul-2026)
   Fuente de datos: assets/guia-talles-data.json (mismo dominio, sin terceros).
   v1.1: sin dependencia de Kiwi en runtime · timeout + reintentar · bolsos solo-tabla. */
(function () {
  "use strict";
  /* guardia: nunca ejecutar dos veces (design mode / doble render del theme) */
  if (window.__GT_LOADED) return;
  window.__GT_LOADED = "3.8";
  try { console.log("[guia-talles] v1.23"); } catch (e) {}
  var root = document.getElementById("gt-root");
  if (!root) return;
  /* limpieza defensiva de instancias previas */
  ["gt-fab", "gt-overlay"].forEach(function (id) {
    var n = document.getElementById(id);
    if (n && n.parentNode) n.parentNode.removeChild(n);
  });
  var HANDLE = root.getAttribute("data-handle");
  var TITLE = root.getAttribute("data-title") || "";
  var SRC = root.getAttribute("data-src");
  var DATA = null;

  var MEASURES = {
    busto:  { q: "¿Cuánto mide tu busto?",  hint: "Con una cinta, por la parte más ancha del busto, horizontal, sin apretar. Es tu cuerpo, no la prenda.", ph: "92" },
    cadera: { q: "¿Cuánto mide tu cadera?", hint: "Por la parte más ancha de la cadera, cinta nivelada, sin apretar.", ph: "100" },
    cintura:{ q: "Tu cintura (opcional, afina el jean)", hint: "Por donde usás el pantalón.", ph: "78" }
  };

  var IMGS = {
    cuerpo: "https://cdn.shopify.com/s/files/1/0565/7794/9792/files/gt-cuerpo-v2.jpg?v=1785416886",
    prendas: {} /* slug -> URL; se completan a medida que Alan pasa cada ilustracion */
  };
  function typeSlug(name) {
    if (/hoodie|canguro|buzo/i.test(name)) return "buzo";
    if (/campera/i.test(name)) return "campera";
    if (/jogger|jogging/i.test(name)) return "jogging";
    if (/bermuda|short/i.test(name)) return "short";
    if (/jean|pantal/i.test(name)) return "jean";
    if (/polera|manga larga/i.test(name)) return "manga-larga";
    if (/tirita|tiras/i.test(name)) return "tiritas";
    if (/top|tank|musculosa|sin mangas/i.test(name)) return "top";
    if (/bag|bolso/i.test(name)) return "bolso";
    return "remera";
  }
  var selloGuia = false;
  function sellarPedidoGuia() {
    /* marca el carrito para poder cruzar después: ¿devuelve menos quien usó la guía? */
    if (selloGuia) return;
    selloGuia = true;
    try {
      fetch("/cart/update.js", { method: "POST", headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ attributes: { "Usó guía de talles": "sí" } }) }).catch(function () {});
    } catch (e) {}
  }
  function ev(n, p) {
    if (n === "talle_aplicado" || n === "talles_aplicados_combo" || n === "talle_ya_puesto") sellarPedidoGuia();
    try {
      window.dataLayer = window.dataLayer || [];
      var o = { event: "gt_" + n };
      for (var k in p) if (Object.prototype.hasOwnProperty.call(p, k)) o[k] = p[k];
      window.dataLayer.push(o);
      if (typeof window.gtag === "function") window.gtag("event", "gt_" + n, p || {});
    } catch (e) {}
  }
  function r2(v) { return Math.round(v / 2) * 2; }
  function num(v) { var n = parseFloat(String(v).replace(",", ".")); return isNaN(n) ? null : n; }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]; }); }
  function tmo(p, ms) {
    return Promise.race([p, new Promise(function (_, rej) { setTimeout(function () { rej(new Error("timeout")); }, ms); })]);
  }

  /* ---------- clasificación (desde el asset propio) ---------- */
  function classify(ch, label) {
    var cols = ch.cols || [], rows = ch.rows || [];
    if (!rows.length) return null;
    var entryIdx = (typeof ch.e === "number" && ch.e > 0) ? ch.e : -1;
    var entryCol = entryIdx > 0 ? (cols[entryIdx] || "") : "";
    var unstrIdx = -1, j;
    for (j = 1; j < cols.length; j++) if (/sin estirar/i.test(cols[j] || "")) { unstrIdx = j; break; }
    var elastic = entryIdx > 0 && (unstrIdx > 0 || /estirad|maxim/i.test(entryCol));
    var measure = /cader/i.test(entryCol) ? "cadera" : (/cintur/i.test(entryCol) ? "cintura" : "busto");
    var cintIdx = -1;
    if (measure === "cadera") for (j = 1; j < cols.length; j++) if (/cintur/i.test(cols[j] || "")) { cintIdx = j; break; }
    var name = ch.n || label || "";
    var buzo = /hoodie|canguro|buzo|campera/i.test(name);
    /* CALCE CALIBRADO (v2, 30-jul-2026)
       ch.t = holgura objetivo de ESTA prenda, derivada del talle que usan los modelos
       en las fotos del sitio (ficha del producto). Ya no se adivina por el nombre.
       Sin ancla propia -> mediana de su grupo (DATA.fb). min y snug son guardarraíles
       universales: solo evitan recomendar algo que no entra. */
    var ease = null, fit;
    var grupo = elastic ? "elastizada-busto" : (measure === "cadera" ? "pantalon" : (measure === "cintura" ? "cintura" : (buzo ? "abrigo" : "top")));
    var fb = (DATA && DATA.fb) ? DATA.fb : {};
    var target = (typeof ch.t === "number") ? ch.t : (typeof fb[grupo] === "number" ? fb[grupo] : (buzo ? 30 : 15));
    /* min y snug son guardarraíles, no calibración: solo evitan recomendar algo
       que no entra. Se toman del objetivo PERO nunca por encima de un piso bajo,
       para no dejar sin talle a quien igual entra cómodo en una prenda muy holgada. */
    var piso = (measure === "cadera") ? -2 : 2;
    var mn = Math.min(Math.round((target - 3) * 10) / 10, piso);
    ease = { min: mn, ideal: target, snug: Math.round((mn - 4) * 10) / 10 };
    if (entryIdx < 0) { ease = null; fit = "MEDIDAS"; }
    else if (elastic) { fit = "AL CUERPO · SE ESTIRA"; }
    else if (measure === "cadera") { fit = "JEAN / PANTALÓN"; }
    /* el badge describe el calce REAL medido, no el nombre comercial */
    else fit = target < 5 ? "AL CUERPO" : (target < 15 ? "REGULAR" : (target < 25 ? "HOLGADO" : "OVERSIZE"));
    /* ¿Se decide con la columna del CONTORNO CÓMODO? (v3.8, 4-sep-2026)
       La segunda columna de una prenda elastizada NO es el tope reventado del
       elástico: es hasta dónde la prenda viste CÓMODA. Por eso es la que manda
       para elegir talle, no la de reposo. Antes decidía el reposo y el cómodo
       solo filtraba si entrabas — eso ignoraba cuánto comprime cada tejido.
       Excepción `ch.ref === "reposo"`: tablas cuyo dato de cómodo no es confiable
       (ver CREAR-O-CAMBIAR-UNA-TABLA.md). Espejo de usa_comodo() en tools/lib.py. */
    var usaComodo = elastic && entryIdx > 0 && unstrIdx > 0 && unstrIdx !== entryIdx && ch.ref !== "reposo";
    if (usaComodo) {
      for (j = 0; j < rows.length; j++) {
        var _su = num(rows[j][unstrIdx]), _es = num(rows[j][entryIdx]);
        if (_su == null || _es == null || _es <= _su) { usaComodo = false; break; }
      }
    }
    var sizes = rows.map(function (r) {
      var rep = unstrIdx > 0 ? num(r[unstrIdx]) : null;
      var mx = elastic && entryIdx > 0 ? num(r[entryIdx]) : null;
      var main;
      if (usaComodo) main = mx;
      else {
        main = entryIdx < 0 ? null : (elastic ? (unstrIdx > 0 ? num(r[unstrIdx]) : null) : num(r[entryIdx]));
        /* si el "máximo" no supera al sin-estirar, la tabla no tiene columna de
           cómodo real (caso Remera Basic) y el tope no aplica */
        if (mx != null && main != null && mx <= main) mx = null;
      }
      return { s: String(r[0]), main: main, max: mx, rep: rep, cint: cintIdx > 0 ? num(r[cintIdx]) : null };
    });
    return { label: label || name, name: name, cols: cols, rows: rows, sizes: sizes, img: ch.img || null,
             elastic: elastic, comodo: usaComodo, measure: entryIdx > 0 ? measure : null, ease: ease, fit: fit, hasCalc: entryIdx > 0 };
  }

  /* ---------- recomendador determinístico ---------- */
  function ranges(it) {
    var ms = it.sizes.map(function (s) { return s.main; });
    return it.sizes.map(function (sz, i) {
      if (sz.main == null || !it.ease) return { s: sz.s, lo: null, hi: null, sz: sz };
      if (it.elastic) {
        /* el rango de cada talle es el de la propia prenda: del "sin estirar" al
           contorno cómodo, que es el tope de ajuste. Entre esos dos números entran
           varias medidas de cuerpo — cuanto más cerca del tope, más al cuerpo.
           Ojo: `main` puede ser el cómodo (ver classify), así que el piso se toma
           siempre de `rep`, nunca de `main`. */
        var lo0 = sz.rep != null ? sz.rep : sz.main;
        return { s: sz.s, lo: lo0, hi: sz.max != null ? sz.max : null, sz: sz };
      }
      var lo = (i > 0 && ms[i - 1] != null) ? Math.round((ms[i - 1] + sz.main) / 2) - it.ease.ideal : sz.main - it.ease.ideal - 8;
      var hi = (i < ms.length - 1 && ms[i + 1] != null) ? Math.round((sz.main + ms[i + 1]) / 2) - it.ease.ideal : sz.main - it.ease.min;
      return { s: sz.s, lo: lo, hi: hi, sz: sz };
    });
  }
  function recommend(it, meas, pref) {
    if (!it || !it.hasCalc) return null;
    var body = meas[it.measure];
    if (body == null) return { missing: true, label: it.label, need: it.measure };
    if (body < (it.measure === "cintura" ? 45 : 55) || body > 185) return { invalid: true, label: it.label, body: body };
    var R = ranges(it), idx = -1, i, tight = false;
    if (it.elastic) {
      /* mismo criterio que las rígidas, medido sobre la columna que decide
         (el contorno CÓMODO si la tabla lo tiene medido, si no el reposo):
         se busca el talle cuya diferencia con tu cuerpo quede más cerca del
         objetivo, siempre que entres dentro de su contorno cómodo. */
      var ec = [];
      for (i = 0; i < it.sizes.length; i++) {
        var sz = it.sizes[i];
        if (sz.main == null) continue;
        /* sin columna de contorno cómodo medida, techo provisorio conservador:
           1.2x el sin-estirar (el estiramiento real medido en el catálogo va de
           1.22x a 1.65x; jersey estira menos que ribb). Se reemplaza cuando el
           depósito mida el contorno cómodo real. */
        var cap = sz.max != null ? sz.max + 2 : sz.main * 1.2;
        if (body <= cap) ec.push({ i: i, hol: sz.main - body });
      }
      if (!ec.length) return { none: true, label: it.label, body: body };
      var eb = ec[0];
      for (i = 1; i < ec.length; i++) if (Math.abs(ec[i].hol - it.ease.ideal) < Math.abs(eb.hol - it.ease.ideal)) eb = ec[i];
      idx = eb.i;
    } else {
      var cands = [];
      for (i = 0; i < it.sizes.length; i++) {
        if (it.sizes[i].main == null) continue;
        var h0 = it.sizes[i].main - body;
        if (h0 >= it.ease.min) cands.push({ i: i, hol: h0 });
      }
      if (!cands.length) {
        var last = it.sizes.length - 1;
        var lm = it.sizes[last].main;
        if (lm != null && lm - body >= it.ease.snug) { cands = [{ i: last, hol: lm - body }]; tight = true; }
        else return { none: true, label: it.label, body: body };
      }
      var best = cands[0];
      for (i = 1; i < cands.length; i++) if (Math.abs(cands[i].hol - it.ease.ideal) < Math.abs(best.hol - it.ease.ideal)) best = cands[i];
      idx = best.i;
    }
    var warn = tight ? "Es el talle más grande: te va a quedar más al cuerpo que el calce pensado para este modelo." : null;
    if (it.elastic && idx >= 0 && it.sizes[idx].max != null && body > it.sizes[idx].max - 2) {
      /* "subí un talle" solo tiene sentido si existe uno más grande */
      warn = (idx < it.sizes.length - 1)
        ? "Va bien al cuerpo, cerca de su contorno cómodo. Si la preferís más relajada, subí un talle."
        : "Es el talle más grande de este modelo. Te va a quedar bien al cuerpo, ajustado: la prenda estira, pero no queda holgada.";
    }
    var idx0 = idx;
    if (!tight && !it.elastic && it.measure === "cadera" && meas.cintura != null && meas.cintura >= 45 && meas.cintura <= 160) {
      while (idx < R.length - 1 && R[idx].sz.cint != null && R[idx].sz.cint < meas.cintura - 2) idx++;
      if (R[idx].sz.cint != null && R[idx].sz.cint < meas.cintura - 2) warn = "Tu cintura (" + meas.cintura + " cm) queda al límite incluso en el talle más grande.";
      else if (idx > idx0) warn = "Por cadera te daba el " + esc(R[idx0].s) + ", pero con tu cintura (" + meas.cintura + " cm) no cerraba: te recomendamos el " + esc(R[idx].s) + ".";
      else if (R[idx].sz.cint != null && R[idx].sz.cint - meas.cintura > 10) warn = "En la cintura te va a sobrar — este modelo es de cadera ancha. Con cinto queda como en la foto.";
    }
    var shifted = false;
    if (pref !== 0) { var ni = idx + pref; if (ni >= 0 && ni < R.length) { idx = ni; shifted = true; } }
    var r = R[idx], hol, why;
    if (it.elastic) {
      /* el texto siempre explica con las DOS columnas: reposo y cómodo.
         `main` puede ser cualquiera de las dos según decida la tabla. */
      var rep = r.sz.rep != null ? r.sz.rep : (it.comodo ? null : r.sz.main);
      hol = rep != null ? body - rep : null;
      why = "La prenda mide <b>" + (rep != null ? rep + " cm" : "—") + "</b> sin estirar" +
            (r.sz.max != null ? " y es cómoda hasta <b>" + r.sz.max + " cm</b>" : ", y el tejido cede") +
            ". Sobre tu medida se ajusta" + (hol != null ? " <b>" + hol + " cm al cuerpo</b>" : "") + ", con resto de confort.";
    } else {
      hol = r.sz.main - body;
      var fitTxt;
      if (tight) fitTxt = ".";
      else if (hol < it.ease.min) fitTxt = " — va a quedar AJUSTADO, marcando el cuerpo.";
      else if (hol < it.ease.ideal * 0.55) fitTxt = " — va al cuerpo, más pegado que en la foto.";
      else if (hol <= it.ease.ideal * 1.45) fitTxt = " — el calce con el que este modelo está pensado.";
      else fitTxt = " — va a quedar más suelto que en la foto.";
      if (shifted) fitTxt = (pref < 0 ? " — un talle menos que el sugerido:" : " — un talle más que el sugerido:") + fitTxt.replace(" —", "");
      why = "La prenda mide <b>" + r.sz.main + " cm</b> plana; sobre tus <b>" + body + " cm</b> quedan <b>" + hol + " cm de holgura</b>" + fitTxt;
    }
    return { label: it.label, size: r.s, hol: hol, why: why, warn: warn, body: body };
  }

  /* ---------- UI ---------- */
  var state = { items: [], calcItems: [], pref: 0, meas: {}, showBody: true, compIdx: 0, built: false, qty: null };

  /* ---- integración con el selector de variantes del theme (Concept) ---- */
  function vPicker() {
    var all = document.querySelectorAll("variant-picker");
    for (var i = 0; i < all.length; i++) {
      var l = all[i].querySelector("label");
      if (l && l.getBoundingClientRect().width > 0) return all[i];
    }
    return all[0] || null;
  }
  function sizeFieldset() {
    var vp = vPicker(); if (!vp) return null;
    var fs = vp.querySelectorAll("fieldset[data-option-slug]");
    for (var i = 0; i < fs.length; i++) if (/talle|size/i.test(fs[i].getAttribute("data-option-slug") || "")) return fs[i];
    return null;
  }
  function colorFieldset() {
    var vp = vPicker(); if (!vp) return null;
    var fs = vp.querySelectorAll("fieldset[data-option-slug]");
    for (var i = 0; i < fs.length; i++) if (/color|colour/i.test(fs[i].getAttribute("data-option-slug") || "")) return fs[i];
    return null;
  }
  function sizeInput(size) {
    var fs = sizeFieldset(); if (!fs) return null;
    var ins = fs.querySelectorAll("input[data-option-value]");
    for (var i = 0; i < ins.length; i++) if (String(ins[i].getAttribute("data-option-value")).trim().toUpperCase() === String(size).trim().toUpperCase()) return ins[i];
    return null;
  }
  function themeVariants() {
    try { var vp = vPicker(); return JSON.parse(vp.querySelector("script[data-variants]").textContent); } catch (e) { return null; }
  }
  /* stock del talle en CUALQUIER color: {ok, avail[]} o null si no se puede saber */
  function stockFor(size) {
    var vs = themeVariants(); if (!vs || !vs.length) return null;
    var sf = sizeFieldset(); if (!sf) return null;
    var sIn = sf.querySelector("input[data-option-index]");
    var sIdx = sIn ? parseInt(sIn.getAttribute("data-option-index") || "1", 10) : 1;
    var availSizes = [], okSize = false;
    for (var i = 0; i < vs.length; i++) {
      var v = vs[i];
      if (!v.available) continue;
      var sv = String(v["option" + sIdx]);
      if (availSizes.indexOf(sv) < 0) availSizes.push(sv);
      if (sv.toUpperCase() === String(size).toUpperCase()) okSize = true;
    }
    return { ok: okSize, avail: availSizes };
  }
  /* selector propio de los productos en liquidación (.liq-talle) */
  function liqBtn(size) {
    var bs = document.querySelectorAll(".liq-talles .liq-talle");
    for (var i = 0; i < bs.length; i++) {
      var v = bs[i].getAttribute("data-name") || bs[i].textContent;
      if (String(v).trim().toUpperCase() === String(size).trim().toUpperCase()) return bs[i];
    }
    return null;
  }
  function applySize(size) {
    var inp = sizeInput(size);
    if (inp) {
      inp.click();
      inp.dispatchEvent(new Event("change", { bubbles: true }));
      return true;
    }
    var lb = liqBtn(size);
    if (lb) { lb.click(); return true; }
    return false;
  }

  /* ---- integración con el armador de combos (app FBT) ---- */
  /* ---- selector propio de packs/outfits de Deliver (.pbx-slot) ----
     Cada slot trae la prenda en data-url y data-title, así que el pack se
     resuelve leyendo la página: no hace falta mapearlo a mano en el JSON. */
  function pbxSlots() { return document.querySelectorAll(".pbx-slot[data-url]"); }
  function pbxHandle(slot) {
    var u = slot.getAttribute("data-url") || "";
    var m = u.match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }
  function pbxCompsFromPage() {
    var out = [], seen = {}, ss = pbxSlots(), i;
    for (i = 0; i < ss.length; i++) {
      var h = pbxHandle(ss[i]);
      if (!h || seen[h]) continue;
      var m = DATA.map[h];
      if (!m || !m.c) continue;
      seen[h] = 1;
      out.push([m.c, ss[i].getAttribute("data-title") || h, h]);
    }
    return out;
  }
  function pbxApply(recs) {
    var n = 0, ss = pbxSlots(), i, j;
    for (i = 0; i < ss.length; i++) {
      var h = pbxHandle(ss[i]);
      for (j = 0; j < recs.length; j++) {
        if (recs[j].handle && recs[j].handle === h) {
          var btns = ss[i].querySelectorAll(".pbx-talle");
          for (var k = 0; k < btns.length; k++) {
            var v = btns[k].getAttribute("data-name") || btns[k].textContent.trim();
            if (String(v).toUpperCase() === String(recs[j].size).toUpperCase()) { btns[k].click(); n++; break; }
          }
          break;
        }
      }
    }
    return n;
  }
  function gfbContainers() { return document.querySelectorAll(".gfbFrequentBoughtWidgetProductContainer"); }
  function gfbFindContainer(rc) {
    var cs = gfbContainers(), i;
    if (rc.handle) for (i = 0; i < cs.length; i++) if (cs[i].getAttribute("data-product-handle") === rc.handle) return cs[i];
    var key = String(rc.label || "").toLowerCase().split(" ").slice(0, 2).join(" ");
    if (key) for (i = 0; i < cs.length; i++) {
      var t = cs[i].querySelector(".gfbFrequentBoughtWidgetProductTitle");
      if (t && t.textContent.toLowerCase().indexOf(key) >= 0) return cs[i];
    }
    return null;
  }
  function gfbApply(recs) {
    var n = 0;
    recs.forEach(function (rc) {
      var cont = gfbFindContainer(rc); if (!cont) return;
      var pills = cont.querySelectorAll(".gfbFrequentBoughtLabelPillsUI");
      for (var j = 0; j < pills.length; j++) {
        if (pills[j].textContent.trim().toUpperCase() === String(rc.size).toUpperCase()) { pills[j].click(); n++; break; }
      }
    });
    return n;
  }

  /* ---- memoria local de medidas (solo en este dispositivo) ---- */
  function loadMeas() {
    try {
      var d = JSON.parse(localStorage.getItem("gt_meas_v1") || "null");
      if (d && d.t && (Date.now() - d.t) < 180 * 864e5) return d;
    } catch (e) {}
    return null;
  }
  function saveMeas() {
    try {
      var d = { t: Date.now() };
      for (var k in state.meas) if (state.meas[k] != null) d[k] = state.meas[k];
      localStorage.setItem("gt_meas_v1", JSON.stringify(d));
    } catch (e) {}
  }

  /* La pestaña lateral "Talles y Medidas" se retiró del diseño (3-ago-2026).
     El acceso es siempre el botón dentro de la ficha. Se conserva el elemento,
     oculto y fuera del flujo, porque el theme todavía lo referencia en algún
     bloque de packs y romper esa referencia daría error de JS. */
  var fab = document.createElement("button");
  fab.id = "gt-fab"; fab.type = "button";
  fab.textContent = "Talles y Medidas";
  fab.setAttribute("aria-haspopup", "dialog");
  fab.hidden = true;
  fab.style.display = "none";
  document.body.appendChild(fab);

  var wrap = document.createElement("div");
  wrap.id = "gt-overlay"; wrap.hidden = true;
  wrap.innerHTML =
    '<div id="gt-modal" role="dialog" aria-modal="true" aria-label="Guía de talles">' +
      '<div class="gt-head"><div><div class="gt-kicker" id="gt-kicker">Guía de talles</div>' +
      '<div class="gt-title" id="gt-title"></div><div class="gt-fits" id="gt-fits"></div></div>' +
      '<button type="button" class="gt-close" id="gt-close" aria-label="Cerrar">✕</button></div>' +
      '<div class="gt-tabs" role="tablist">' +
        '<button type="button" class="gt-tab" id="gt-tabA" role="tab" aria-selected="true">Encontrá tu talle</button>' +
        '<button type="button" class="gt-tab" id="gt-tabB" role="tab" aria-selected="false">Medidas</button></div>' +
      '<div class="gt-body" id="gt-panA"><div id="gt-loading">Cargando la guía… <span style="opacity:.4;font-size:11px">v1.22</span></div>' +
        '<div id="gt-error" hidden><p class="gt-cur">No pudimos cargar la guía. Puede ser un tema de conexión.</p>' +
        '<button type="button" class="gt-retry" id="gt-retry">Reintentar</button></div>' +
        '<div id="gt-calc" hidden><div id="gt-inputs"></div>' +
        '<details class="gt-how"><summary>¿Cómo me tomo las medidas?</summary>' +
        '<img loading="lazy" alt="Dónde medir busto, cintura y cadera" src="https://cdn.shopify.com/s/files/1/0565/7794/9792/files/gt-cuerpo-v2.jpg?v=1785416886">' +
        '<ul class="gt-ul">' +
        '<li><b>Pecho / busto:</b> por la parte más ancha, cinta horizontal.</li>' +
        '<li><b>Cintura:</b> por la parte más fina, justo arriba del ombligo.</li>' +
        '<li><b>Cadera:</b> por la parte más ancha, a la altura de los glúteos.</li></ul>' +
        '<p class="gt-note" style="padding:0 14px 12px;margin:0">La cinta va apoyada al cuerpo, sin apretar. Medí en ropa interior o ropa finita.</p>' +
        '</details>' +
        '<div class="gt-preflbl">¿Cómo te gusta que quede?</div>' +
        '<div class="gt-seg" id="gt-pref">' +
          '<button type="button" data-p="-1">Más al cuerpo</button>' +
          '<button type="button" data-p="0" aria-pressed="true">Como en la foto</button>' +
          '<button type="button" data-p="1">Más suelto</button></div>' +
        '<div id="gt-results"></div>' +
        '<p class="gt-note" id="gt-empty">Completá tu medida y te decimos el talle — con el porqué.</p>' +
        '<p class="gt-note">Tus medidas quedan guardadas solo en tu dispositivo para la próxima vez. Viajan redondeadas y anónimas, sin tu nombre.</p></div>' +
        '<div id="gt-curated" hidden><p class="gt-cur" id="gt-curmsg"></p></div></div>' +
      '<div class="gt-body" id="gt-panB" hidden><div class="gt-comp" id="gt-comp"></div>' +
        '<div class="gt-toggle" id="gt-toggle"><button type="button" id="gt-tgB" aria-pressed="true">Medidas corporales</button>' +
        '<button type="button" id="gt-tgG" aria-pressed="false">Medidas de la prenda</button></div>' +
        '<p class="gt-mnote" id="gt-mnote"></p><div id="gt-table"></div>' +
        '<details class="gt-how"><summary>¿Cómo se toman estas medidas?</summary><div id="gt-howbody"></div></details>' +
        '<p class="gt-note">Medidas tomadas a mano con la prenda plana. Puede variar 2–3 cm entre unidades.</p></div>' +
    '</div>';
  document.body.appendChild(wrap);
  /* lookups scoped al propio modal: inmune a IDs duplicados */
  var $ = function (id) { return wrap.querySelector("#" + id) || document.getElementById(id); };

  var lastFocus = null;
  function open() {
    lastFocus = document.activeElement;
    wrap.hidden = false;
    wrap.classList.add("gt-open");
    document.documentElement.classList.add("gt-lock"); document.body.classList.add("gt-lock");
    ev("guia_abierta", { producto: HANDLE });
    if (!state.built) load();
    else if (state.calcItems.length) renderResults();
    setTimeout(function () {
      var f = wrap.querySelector("#gt-inputs input") || $("gt-close");
      if (f) try { f.focus({ preventScroll: true }); } catch (e) { f.focus(); }
    }, 60);
  }
  function close() {
    /* Sin esto no se sabe qué pasa con quien cierra sin aplicar: si ya tenía el
       talle puesto, si nunca llegó a una recomendación, o si se fue sin nada. */
    try {
      if (!wrap.hidden){
        var conRec = state.lastRecs && state.lastRecs.length ? 1 : 0;
        ev("cerrar", { producto: HANDLE, con_recomendacion: conRec,
                       aplico: selloGuia ? 1 : 0 });
      }
    } catch (e) {}
    wrap.hidden = true;
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} }
    wrap.classList.remove("gt-open");
    document.documentElement.classList.remove("gt-lock"); document.body.classList.remove("gt-lock");
  }
  fab.addEventListener("click", open);
  var ICONO = "";
  var inlineTries = 0;
  /* El theme trae en los packs un botón propio (#pbx-gt-open) que abría la pestaña
     lateral. Con el botón inline de la guía queda duplicado, así que se retira.
     Se hace por JS y no por CSS porque el theme lo estiliza con !important. */
  /* Devuelve el bloque "Medidas del/la modelo" (el hijo directo de la ficha que
     lo contiene), para poder dejar el botón SIEMPRE arriba de él. */
  function bloqueModelo() {
    var d = document.querySelector(".deliver-medidas");
    if (!d) return null;
    var info = document.querySelector(".product__info");
    var el = d;
    while (el.parentElement && el.parentElement !== info && el.parentElement !== document.body) el = el.parentElement;
    return el;
  }
  /* Inserta el botón respetando el orden: botón -> Medidas del/la modelo -> talles.
     Si la ficha no tiene el bloque del modelo, usa el ancla que le pasen. */
  function ponerBoton(b, ancla, clase) {
    b.className = clase || "gt-inline--block";
    var m = bloqueModelo();
    if (m) {
      m.classList.add("gt-modelo-acc");
      m.insertAdjacentElement("beforebegin", b);
      return;
    }
    ancla.insertAdjacentElement("beforebegin", b);
  }
  /* Botones propios del theme que hacían de acceso a la guía. Con el botón
     inline quedan duplicados, así que se retiran. Se hace por JS y no por CSS
     porque el theme los estiliza con !important. */
  var BOTONES_VIEJOS = ["pbx-gt-open", "LIQGT"];
  function quitarBotonViejo() {
    for (var i = 0; i < BOTONES_VIEJOS.length; i++) {
      var v = document.getElementById(BOTONES_VIEJOS[i]);
      if (v && v.parentNode) v.parentNode.removeChild(v);
    }
    /* red de seguridad: cualquier otro botón del theme con el mismo texto */
    var todos = document.querySelectorAll(".product__info button, .product__info a");
    for (var j = 0; j < todos.length; j++) {
      var el = todos[j];
      if (el.id === "gt-inline") continue;
      if (/mejor talle para m/i.test(el.textContent || "") && el.parentNode) el.parentNode.removeChild(el);
    }
  }
  /* Los selectores de talles son 4 y algunos los inyecta una app despues de que
     carga la pagina. Devuelve el que haya, o null si todavia no hay ninguno. */
  function anclaTalles() {
    var vp = vPicker();
    if (vp && sizeFieldset()) return { el: vp };
    var g = document.querySelector(".gfbFrequentBoughtReplacableContent");
    if (g) return { el: g, fbt: true };
    /* packs/outfits propios: arriba del bloque de talles */
    var pb = document.querySelector(".pbx-all") || document.querySelector(".pbx-slot");
    if (pb) return { el: pb };
    /* productos en liquidación: arriba de su selector de talles */
    var lq = document.querySelector(".liq-talles");
    if (lq) return { el: lq };
    return null;
  }
  function ubicar(b, a) {
    if (a.fbt && !bloqueModelo()) {
      b.className = "gt-inline--combo";
      a.el.insertAdjacentElement("afterbegin", b);
      return;
    }
    ponerBoton(b, a.el);
  }
  /* Productos sin selector de talles (bolsos): el botón va junto al bloque de
     compra, no al final de la ficha — ahí abajo no lo ve nadie. */
  function ubicarFallback(b) {
    var info = document.querySelector(".product__info");
    if (!info) return false;
    b.className = "gt-inline--block";
    var m = bloqueModelo();
    if (m) { m.classList.add("gt-modelo-acc"); m.insertAdjacentElement("beforebegin", b); return true; }
    var compra = info.querySelector('[name="add"], .product-form__submit, product-form, .buy-buttons');
    while (compra && compra.parentElement && compra.parentElement !== info) compra = compra.parentElement;
    if (compra && compra.parentElement === info) compra.insertAdjacentElement("beforebegin", b);
    else info.appendChild(b);
    return true;
  }
  function textoBoton(b, conTalles) {
    b.innerHTML = ICONO + "<span>" + (conTalles ? "¿Cuál es el mejor talle para mí?" : "Ver medidas") + "</span>";
  }
  (function inlineLink() {
    if (document.getElementById("gt-inline")) return;
    var b = document.createElement("button");
    b.type = "button"; b.id = "gt-inline";
    ICONO = '<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="2" y="9" width="20" height="6" rx="1.5"/><path d="M6 9v3M10 9v2.2M14 9v3M18 9v2.2"/></svg>';
    b.innerHTML = ICONO + '<span>¿Cuál es el mejor talle para mí?</span>';
    /* productos sin talle (bolsos): el texto correcto es otro */
    b.setTextoSegunProducto = function () {
      var soloMedidas = state.items.length && !state.calcItems.length;
      if (soloMedidas) b.innerHTML = ICONO + "<span>Ver medidas</span>";
    };
    b.addEventListener("click", open);
    quitarBotonViejo();
    /* marca cuando quedó visible el botón, en ms desde que arrancó la página.
       Sirve para medir regresiones de tiempo sin tener que instrumentar a mano. */
    function marcar() { try { window.__GT_BTN_MS = Math.round(performance.now()); } catch (e) {} }
    var a = anclaTalles();
    if (a) { textoBoton(b, true); ubicar(b, a); marcar(); return; }
    /* dos intentos cortos de gracia por si el theme lo pinta un tick despues */
    if (++inlineTries < 3) { setTimeout(inlineLink, 150); return; }
    /* Sin selector: el botón se muestra YA. Antes se esperaba 5,6 s antes de
       decidir y en los bolsos el cliente veía la ficha sin botón todo ese rato. */
    textoBoton(b, false);
    if (!ubicarFallback(b)) { if (inlineTries < 8) setTimeout(inlineLink, 700); return; }
    marcar();
    /* ...y si una app inyecta el selector mas tarde, se reubica y se re-etiqueta solo */
    var vueltas = 0;
    var tid = setInterval(function () {
      quitarBotonViejo();
      var a2 = anclaTalles();
      if (a2) { clearInterval(tid); textoBoton(b, true); ubicar(b, a2); return; }
      if (++vueltas >= 15) clearInterval(tid);
    }, 400);
  })();
  $("gt-close").addEventListener("click", close);
  wrap.addEventListener("click", function (e) { if (e.target === wrap) close(); });
  document.addEventListener("keydown", function (e) { if (e.key === "Escape" && !wrap.hidden) close(); });
  /* con el modal abierto, Tab no se escapa a la pagina de atras */
  wrap.addEventListener("keydown", function (e) {
    if (e.key !== "Tab" || wrap.hidden) return;
    var f = Array.prototype.filter.call(
      wrap.querySelectorAll('a[href],button,input,select,textarea,summary,[tabindex]:not([tabindex="-1"])'),
      function (el) { return el.offsetParent !== null && !el.disabled; });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });
  $("gt-retry").addEventListener("click", function () { state.built = false; load(); });

  function showError() {
    $("gt-loading").hidden = true;
    $("gt-error").hidden = false;
    ev("guia_error", { producto: HANDLE });
  }
  function showMsg(txt) {
    $("gt-loading").hidden = true;
    $("gt-curmsg").textContent = txt;
    $("gt-curated").hidden = false;
    $("gt-tabB").style.display = "none";
  }

  function load() {
    state.built = true;
    $("gt-loading").hidden = false;
    $("gt-error").hidden = true;
    $("gt-title").textContent = TITLE;
    /* vigilante: pase lo que pase, a los 10 s no puede seguir diciendo "Cargando" */
    setTimeout(function () {
      if (!$("gt-loading").hidden) showError();
    }, 10000);
    var pData = DATA ? Promise.resolve(DATA) : tmo(fetch(SRC, { credentials: "omit" }).then(function (r) {
      if (!r.ok) throw new Error(r.status); return r.json();
    }), 8000);
    pData.then(function (d) {
      DATA = d;
      try { build(); } catch (e) { showError(); }
    }).catch(function () { showError(); });
  }

  /* lee los productos que el pack ofrece en la pagina y los resuelve contra el dataset.
     devuelve [] si no encuentra nada usable -> el caller cae al mensaje de siempre */
  function gCompsFromPage() {
    var out = [], seen = {}, cs = gfbContainers(), i;
    for (i = 0; i < cs.length; i++) {
      var h = cs[i].getAttribute("data-product-handle");
      if (!h || seen[h]) continue;
      var m = DATA.map[h];
      if (!m || !m.c) continue;
      seen[h] = 1;
      var t = cs[i].querySelector(".gfbFrequentBoughtWidgetProductTitle");
      out.push([m.c, (t && t.textContent.trim()) || h, h]);
    }
    return out;
  }

  function build() {
    var meta = DATA.map[HANDLE];
    /* pack/outfit nuevo que todavía no está en el mapa: se arma leyendo sus slots */
    if (!meta && pbxSlots().length) meta = { k: "g" };
    if (!meta) return showMsg("Este producto todavía no tiene tabla de medidas cargada. Escribinos por WhatsApp y te pasamos las medidas al toque.");
    /* packs armables ("guardarropa", "mix"): los componentes NO estan en el dataset,
       se leen del widget de la propia pagina para que sigan al pack si cambia */
    var defs;
    if (meta.k === "g") {
      defs = gCompsFromPage();
      if (!defs.length) defs = pbxCompsFromPage();
      if (!defs.length) return showMsg("Este pack se arma adentro de esta página: elegís cada prenda y su talle en el selector. La guía de talles de cada prenda está en su propia página de producto.");
    } else {
      defs = meta.c ? [[meta.c, TITLE, HANDLE]] : (meta.comps || []).map(function (c) { return [c[1], c[0], c[2] || ""]; });
    }
    if (meta.q) state.qty = meta.q;
    var items = [];
    defs.forEach(function (d) {
      var ch = DATA.charts[d[0]];
      var it = ch ? classify(ch, d[1]) : null;
      if (it) { it.handle = d[2] || ""; items.push(it); }
    });
    if (!items.length) return showMsg("Este producto todavía no tiene tabla de medidas cargada. Escribinos por WhatsApp y te pasamos las medidas al toque.");
    state.items = items;
    state.calcItems = items.filter(function (it) { return it.hasCalc; });
    $("gt-loading").hidden = true;
    renderHead(); renderComp(); renderTable();
    if (!state.calcItems.length) {
      var bi = document.getElementById("gt-inline");
      if (bi && bi.setTextoSegunProducto) bi.setTextoSegunProducto();
      /* solo tabla (bolsos): directo a Medidas */
      $("gt-tabA").style.display = "none";
      sel(false);
      $("gt-toggle").style.display = "none";
      state.showBody = false; renderTable();
      return;
    }
    $("gt-calc").hidden = false;
    renderInputs();
    var saved = loadMeas();
    if (saved) {
      Array.prototype.forEach.call($("gt-inputs").querySelectorAll("input"), function (inp) {
        var m = inp.getAttribute("data-m");
        if (saved[m] != null) { inp.value = saved[m]; state.meas[m] = saved[m]; }
      });
    }
    renderResults();
  }

  function renderHead() {
    var h = "";
    state.items.forEach(function (it, i) {
      var lbl = state.items.length > 1 ? esc(it.label.split(" ").slice(0, 3).join(" ")) + " · " + it.fit : "CALCE " + it.fit;
      h += '<span class="gt-fit' + (i % 2 ? " alt" : "") + '">' + lbl + "</span>";
    });
    if (state.qty) h += '<span class="gt-fit alt">PACK ×' + state.qty + "</span>";
    $("gt-fits").innerHTML = h;
    $("gt-kicker").textContent = state.items.length > 1 ? "Guía de talles · un talle por prenda" : "Guía de talles";
  }
  function needed() {
    var out = [], has = {};
    state.calcItems.forEach(function (it) { if (it.measure && !has[it.measure]) { has[it.measure] = 1; out.push(it.measure); } });
    var jean = state.calcItems.some(function (it) { return !it.elastic && it.measure === "cadera"; });
    if (jean && !has.cintura) out.push("cintura");
    return out;
  }
  function renderInputs() {
    var h = "";
    needed().forEach(function (m) {
      var M = MEASURES[m];
      h += '<p class="gt-q">' + M.q + '</p><p class="gt-hint">' + M.hint + "</p>" +
        '<div class="gt-inrow"><input type="text" inputmode="decimal" autocomplete="off" enterkeyhint="done" maxlength="6" placeholder="' + M.ph + '" data-m="' + m + '" aria-label="' + M.q + '"><span>cm</span></div>';
    });
    $("gt-inputs").innerHTML = h;
    Array.prototype.forEach.call($("gt-inputs").querySelectorAll("input"), function (inp) {
      inp.addEventListener("input", function () {
        /* se aceptan coma y punto: en Argentina se escribe 92,5 */
        var limpio = inp.value.replace(/[^0-9.,]/g, "");
        if (limpio !== inp.value) inp.value = limpio;
        var v = num(inp.value);
        state.meas[inp.getAttribute("data-m")] = v;
        if (v != null && v > 40) { saveMeas(); ev("medida_ingresada", { tipo: inp.getAttribute("data-m"), cm: r2(v), producto: HANDLE }); }
        renderResults();
      });
    });
  }
  Array.prototype.forEach.call(document.querySelectorAll("#gt-pref button"), function (b) {
    b.addEventListener("click", function () {
      state.pref = parseInt(b.getAttribute("data-p"), 10);
      Array.prototype.forEach.call(document.querySelectorAll("#gt-pref button"), function (x) { x.setAttribute("aria-pressed", "false"); });
      b.setAttribute("aria-pressed", "true");
      ev("preferencia", { pref: state.pref });
      renderResults();
    });
  });
  function renderResults() {
    var any = false, h = "", pend = [];
    state.lastRecs = [];
    state.calcItems.forEach(function (it) {
      var r = recommend(it, state.meas, state.pref);
      if (!r) return;
      if (r.missing) { pend.push(r); return; }
      any = true;
      if (r.invalid) {
        h += '<p class="gt-note">La medida va en centímetros — por ejemplo, 92. Revisá el número que pusiste.</p>';
        return;
      }
      if (r.none) {
        h += '<div class="gt-res"><div class="gt-res-top"><div class="gt-res-name">' + esc(r.label) + "<small>sin talle para tu medida</small></div>" +
             '<div class="gt-res-size">—</div></div><div class="gt-res-why">Con ' + r.body + " cm quedás por encima del talle más grande de este modelo. Mejor decírtelo acá que después en una devolución.</div></div>";
        ev("sin_talle", { producto: HANDLE, item: r.label, cm: r2(r.body) });
        return;
      }
      var stk = state.items.length === 1 ? stockFor(r.size) : null;
      var stockWarn = "", pickBtn = "";
      if (stk && !stk.ok) {
        stockWarn = '<div class="gt-res-warn">El ' + esc(r.size) + " está agotado por ahora en todos los colores." +
          (stk.avail.length ? " Hay stock en: <b>" + stk.avail.map(esc).join(", ") + "</b>." : "") + "</div>";
        ev("talle_sin_stock", { producto: HANDLE, talle: r.size });
      } else if (state.items.length === 1 && (sizeInput(r.size) || liqBtn(r.size))) {
        /* La ficha viene con el primer talle ya marcado (casi siempre S), y S es
           justo el talle más recomendado. En esos casos "Elegir talle S" no cambia
           nada: la persona ve que ya está puesto y cierra. Se contaba como abandono
           cuando en realidad la guía había funcionado.
           Ahora se confirma en vez de pedir una acción vacía. */
        var yaPuesto = sizeInput(r.size);
        if (yaPuesto && yaPuesto.checked) {
          pickBtn = '<div class="gt-ok" data-gt-ya="' + esc(r.size) + '">' +
                    'Ya tenés el <b>' + esc(r.size) + '</b> seleccionado — podés agregarlo</div>';
          ev("talle_ya_puesto", { producto: HANDLE, talle: r.size });
        } else {
          pickBtn = '<button type="button" class="gt-pick" data-gt-size="' + esc(r.size) + '">Elegir talle ' + esc(r.size) + "</button>";
        }
      }
      h += '<div class="gt-res"><div class="gt-res-top"><div class="gt-res-name">' + esc(r.label) + "<small>tu talle</small></div>" +
           '<div class="gt-res-size">' + esc(r.size) + "</div></div>" +
           '<div class="gt-res-why">' + r.why + "</div>" +
           (r.warn ? '<div class="gt-res-warn">' + r.warn + "</div>" : "") + stockWarn + pickBtn + "</div>";
      state.lastRecs.push({ label: r.label, size: r.size, handle: it.handle || "" });
      ev("talle_recomendado", { producto: HANDLE, item: r.label, talle: r.size, pref: state.pref });
    });
    /* el aviso sale solo si YA cargó alguna medida: si no puso nada todavía,
       alcanza con el mensaje normal de "completá tu medida" */
    var empezo = false;
    for (var mk in state.meas) if (state.meas[mk] != null) { empezo = true; break; }
    if (pend.length && empezo) {
      var necesita = {}, k;
      for (k = 0; k < pend.length; k++) necesita[pend[k].need] = 1;
      var faltan = Object.keys(necesita);
      var prendas = pend.map(function (p) { return p.label; });
      h += '<div class="gt-missing"><div class="gt-missing-t">Falta un dato para ' +
        (prendas.length === 1 ? "una prenda" : prendas.length + " prendas") + "</div>" +
        "<p>Completá <b>tu " + faltan.join("</b> y <b>tu ") + "</b> y te decimos el talle de " +
        prendas.map(esc).join(", ") + ".</p>" +
        '<button type="button" class="gt-gotomeas" data-m="' + esc(faltan[0]) + '">Completar ' + esc(faltan[0]) + "</button></div>";
      ev("medida_faltante", { producto: HANDLE, faltan: faltan.join(","), prendas: prendas.length });
    }
    if (state.items.length > 1 && state.lastRecs.length && (gfbContainers().length || pbxSlots().length)) {
      h += '<button type="button" class="gt-pick" id="gt-apply-combo">Aplicar estos talles en el combo</button>';
    }
    $("gt-results").innerHTML = h;
    $("gt-empty").hidden = any;
    var gm = $("gt-results").querySelector(".gt-gotomeas");
    if (gm) gm.addEventListener("click", function () {
      var inp = $("gt-inputs").querySelector('input[data-m="' + gm.getAttribute("data-m") + '"]');
      if (inp) { inp.scrollIntoView({ block: "center", behavior: "smooth" }); setTimeout(function () { inp.focus(); }, 300); }
    });
    var ac = $("gt-apply-combo");
    if (ac) ac.addEventListener("click", function () {
      var n = gfbContainers().length ? gfbApply(state.lastRecs) : pbxApply(state.lastRecs);
      ev("talles_aplicados_combo", { producto: HANDLE, aplicados: n, total: state.lastRecs.length });
      if (n > 0) close();
    });
    Array.prototype.forEach.call($("gt-results").querySelectorAll(".gt-pick[data-gt-size]"), function (b) {
      b.addEventListener("click", function () {
        var s = b.getAttribute("data-gt-size");
        if (applySize(s)) { ev("talle_aplicado", { producto: HANDLE, talle: s }); close(); }
      });
    });
  }
  function renderComp() {
    var el = $("gt-comp");
    if (state.items.length < 2) { el.innerHTML = ""; el.hidden = true; return; }
    el.hidden = false;
    el.innerHTML = state.items.map(function (it, i) {
      return '<button type="button" aria-pressed="' + (i === state.compIdx) + '" data-i="' + i + '">' + esc(it.label.split(" ").slice(0, 3).join(" ")) + "</button>";
    }).join("");
    Array.prototype.forEach.call(el.querySelectorAll("button"), function (b) {
      b.addEventListener("click", function () { state.compIdx = parseInt(b.getAttribute("data-i"), 10); renderComp(); renderTable(); });
    });
  }
  function niceCol(c) {
    var s = String(c || "").toLowerCase();
    var base;
    if (/correa/.test(s)) base = "Largo de correa";
    else if (/botamanga/.test(s)) base = "Botamanga";
    else if (/tiro/.test(s)) base = "Tiro";
    else if (/manga/.test(s)) base = /contorno/.test(s) ? "Contorno de manga" : "Manga";
    else if (/cader/.test(s)) base = "Cadera";
    else if (/cintur/.test(s)) base = "Cintura";
    else if (/bust|pech/.test(s)) base = "Busto";
    else if (/alto/.test(s)) base = "Alto";
    else if (/ancho/.test(s)) base = "Ancho";
    else if (/largo/.test(s)) base = "Largo";
    else return String(c || "");
    if (/sin estirar/.test(s)) return base + " (sin estirar)";
    if (/estirad|maxim/.test(s)) return base + " (cómoda hasta)";
    return base;
  }
  function renderTable() {
    var it = state.items[state.compIdx];
    if (!it) return;
    var bodyView = state.showBody && it.hasCalc;
    var soloMedidas = !it.hasCalc;
    var colHead = bodyView ? "Tu " + (it.measure || "medida") + " (cm)"
                           : (soloMedidas ? "Medidas (cm)" : "La prenda (cm)");
    var h = '<div class="gt-tw"><table class="gt-t"><thead><tr><th class="gt-stick">' + colHead + '</th>';
    /* con un solo talle la etiqueta no aporta (y en los bolsos viene mal cargada) */
    var unaSolaFila = it.sizes.length === 1;
    it.sizes.forEach(function (sz) { h += "<th>" + (unaSolaFila ? "" : esc(sz.s)) + "</th>"; });
    h += "</tr></thead><tbody>";
    if (state.showBody && it.hasCalc) {
      $("gt-mnote").innerHTML = it.elastic
        ? (it.sizes.some(function (sz) { return sz.max != null; })
          ? "Medí tu " + (it.measure || "cuerpo") + " y fijate en qué talle entra. Es elastizada: cada talle cubre desde el <b>sin estirar</b> hasta su <b>contorno cómodo</b> — entran varias medidas. Cerca del cómodo te queda bien al cuerpo; cerca del inicio, más relajada."
          : "Medí tu " + (it.measure || "cuerpo") + " y compará con el <b>sin estirar</b>. Es elastizada: el tejido cede varios centímetros, así que cada talle cubre varias medidas — cuanto más arriba del número, más al cuerpo.")
        : "Medí tu " + (it.measure || "cuerpo") + " y buscá el número en la tabla.<br><b>Ideal</b> = te queda como en la foto. <b>Ajustado</b> = entra, pero va pegado al cuerpo.";
      var R = ranges(it);
      var mLbl = it.measure.charAt(0).toUpperCase() + it.measure.slice(1);
      var hayTope = !it.elastic || it.sizes.some(function (sz) { return sz.max != null; });
      h += '<tr><td class="gt-stick">' + (it.elastic ? mLbl + " sin estirar" : "Ideal desde") + "</td>";
      R.forEach(function (r) { h += "<td>" + (r.lo != null ? r.lo : "—") + "</td>"; });
      h += "</tr>";
      if (hayTope) {
        h += '<tr><td class="gt-stick">' + (it.elastic ? "Cómoda hasta (queda al cuerpo)" : "Ideal hasta") + "</td>";
        R.forEach(function (r) { h += "<td>" + (r.hi != null ? r.hi : "—") + "</td>"; });
        h += "</tr>";
      }
      if (!it.elastic && it.ease) {
        h += '<tr><td class="gt-stick">Ajustado hasta</td>';
        it.sizes.forEach(function (sz) { h += "<td>" + (sz.main != null ? sz.main - it.ease.snug : "—") + "</td>"; });
        h += "</tr>";
      }
      if (!it.elastic && it.measure === "cadera" && it.sizes[0] && it.sizes[0].cint != null) {
        h += '<tr class="gt-rowalt"><td class="gt-stick">Cintura de la prenda</td>';
        it.sizes.forEach(function (sz) { h += "<td>" + (sz.cint != null ? sz.cint : "—") + "</td>"; });
        h += "</tr>";
      }
    } else {
      $("gt-mnote").innerHTML = it.hasCalc
        ? (it.elastic
          ? "Estas son las medidas de la prenda, no las del cuerpo. Se toma sin estirar y estirada hasta donde sigue quedando cómoda."
          : "Estas son las medidas de la prenda, no las del cuerpo. Se apoya plana sobre la mesa y se mide el contorno completo.")
        : "Medidas del producto, en centímetros.";
      for (var j = 1; j < it.cols.length; j++) {
        h += '<tr><td class="gt-stick">' + esc(niceCol(it.cols[j])) + "</td>";
        it.rows.forEach(function (r) { h += "<td>" + esc(r[j] != null ? r[j] : "—") + "</td>"; });
        h += "</tr>";
      }
    }
    h += "</tbody></table></div>";
    $("gt-table").innerHTML = h;
    var hb = $("gt-howbody");
    if (hb) {
      if (state.showBody && it.hasCalc) {
        hb.innerHTML = '<p class="gt-himg"><b>Tu cuerpo</b> — dónde pasa la cinta:</p>' +
          '<img loading="lazy" alt="Dónde medir pecho, cintura y cadera" src="' + IMGS.cuerpo + '">' +
          '<ul class="gt-ul"><li><b>Pecho / busto:</b> por la parte más ancha, cinta horizontal.</li>' +
          '<li><b>Cintura:</b> por la parte más fina, justo arriba del ombligo.</li>' +
          '<li><b>Cadera:</b> por la parte más ancha, a la altura de los glúteos.</li></ul>' +
          '<p class="gt-note" style="padding:0 14px 12px;margin:0">La cinta va apoyada al cuerpo, sin apretar.</p>';
      } else {
        var reg = (it.img && DATA && DATA.imgs) ? DATA.imgs[it.img] : null;
        if (!reg) { try { console.info("[guia-talles] chart sin ilustración:", it.name); } catch (e) {} }
        hb.innerHTML = '<p class="gt-himg"><b>' + esc(it.label) + '</b> — así la medimos:</p>' +
          (reg ? '<img class="gt-pimg" loading="lazy" alt="' + esc(reg.alt) + '" src="' + reg.src + '">' : '') +
          '<p class="gt-note" style="padding:0 14px 12px;margin:0">Plana sobre la mesa, de costura a costura. Por eso el contorno de la tabla es el ancho × 2.</p>';
        var pim = hb.querySelector(".gt-pimg");
        if (pim) pim.addEventListener("error", function () { pim.hidden = true; });
      }
    }
  }
  $("gt-tgB").addEventListener("click", function () { state.showBody = true; this.setAttribute("aria-pressed", "true"); $("gt-tgG").setAttribute("aria-pressed", "false"); renderTable(); });
  $("gt-tgG").addEventListener("click", function () { state.showBody = false; this.setAttribute("aria-pressed", "true"); $("gt-tgB").setAttribute("aria-pressed", "false"); renderTable(); });
  $("gt-tabA").addEventListener("click", function () { sel(true); });
  $("gt-tabB").addEventListener("click", function () { sel(false); ev("tab_medidas", { producto: HANDLE }); });
  function sel(a) {
    $("gt-tabA").setAttribute("aria-selected", a); $("gt-tabB").setAttribute("aria-selected", !a);
    $("gt-panA").hidden = !a; $("gt-panB").hidden = a;
  }
})();
